{
	"title": "Istoricul tranzacțiilor {{productName}}",
	"item": {
		"time": "Ora",
		"description": "Descriere",
		"transactionId": "ID tranzacție",
		"showIds": "Afișează ID-urile",
		"depositTitle": "Assurance de la DNV, care permite o depunere în banca de carbon",
		"depositDescription": "După ce organismul de assurance terță parte „DNV” a asigurat volumul de CO\u2082 captat și stocat într-un sistem digital Monitor-Report-Verify, se efectuează o nouă depunere în banca de carbon.",
		"withdrawalTitle": "Factură către furnizor, care declanșează o retragere din banca de carbon",
		"withdrawalDescription": "Odată cu facturarea materialului evoZero către furnizor, a fost executată o retragere din banca de carbon.",
		"transferTitle": "Transferul reducerilor de CO\u2082 către deținătorul declarației",
		"transferDescription": "Furnizorul a inițiat transferul reducerilor de CO\u2082 către deținătorul declarației, pe baza volumului de material evoZero care a intrat în produsul livrat."
	},
	"proofIdsModal": {
		"titleTransactions": "Vezi tranzacțiile",
		"titleMeasurements": "Vezi măsurătorile",
		"paragraph1": "Un pas de tranzacție pe {{productName}} implică agregarea tranzacțiilor în registrul distribuit. Mai jos găsiți o listă de linkuri către servicii terțe unde puteți vizualiza aceste tranzacții.",
		"paragraph2": "Rețineți că aceste linkuri vă vor duce către site-uri externe care oferă funcționalități de vizualizare a tranzacțiilor.",
		"open": "Deschide",
		"close": "Închide"
	},
	"errors": {
		"fetch": "Nu s-a putut prelua istoricul activității"
	}
}
